import type { MessageDesignTokens } from '@primeuix/themes/types/message';

/**
 * Message component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/message/index.ts
 *
 * Component documentation:
 * https://primeng.org/message
 */
export const messageComponentTokens: Partial<MessageDesignTokens> = {
  colorScheme: {
    light: {
      warn: {
        color: '{yellow.900}',
      },
    },
  },
};
